import React, { FC } from 'react';
import styled from 'styled-components';
import { components, SingleValueProps } from 'react-select';

export type TSingleValue = FC<
  SingleValueProps<{ custom?: boolean; CustomComponent?: FC<any> }>
>;

export const SingleValue: TSingleValue = React.memo(props => {
  const { data, innerProps, selectProps } = props;
  const { custom, CustomComponent } = data;
  const { menuIsOpen } = selectProps;

  const Component =
    CustomComponent &&
    styled(CustomComponent)`
      font-size: 16px;
      font-weight: ${menuIsOpen ? 400 : 600};
      color: ${menuIsOpen ? 'lightgrey' : 'black'};
    `;

  return custom && Component ? (
    <Component {...innerProps} />
  ) : (
    <components.SingleValue {...props} />
  );
});

SingleValue.displayName = 'SingleValue';
